goog.provide('el8.ptdata.ptAllergies');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.PatientItemSet');
goog.require('el8.data.allergies');
goog.require('el8.data.snomedCodes');
goog.require('el8.appservice.notifier');
goog.require('el8.template.ptdata.ptAllergies');


el8.ptdata.ptAllergies = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makePatientItem();

    _class.addStringProperty('status', true);
    _class.addStringProperty('reaction', true);
    _class.addStringProperty('severity', true);
    _class.addDate('startDate', true);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.allergy) {
            spec.allergy_id = el8.data.allergies.create(spec.allergy).getId();
        }
        if (spec.reaction_snomed) {
            spec.reaction_snomed_id = el8.data.snomedCodes.create(spec.reaction_snomed).getId();
        }
        this.parent.populate.call(this, spec);
    };
    _class.addIntProperty('allergyId', true);
    /** For saving new allergies **/
    _class.addStringProperty('manualAllergyName', true);
    _class.addStringProperty('manualReactionSnomedDescription', true);
    _class.addIntProperty('reactionSnomedId', true);

    /**
     * Custom asSoyMap method
     */
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        delete mapped['manualAllergyName'];
        delete mapped['allergyId'];
        delete mapped['manualReactionSnomedDescription'];
        delete mapped['reactionSnomedId'];
        mapped['allergy'] = this.getAllergy().asSoyMap();
        if (this.getReactionSnomed()) {
          mapped['reactionSnomedId'] = this.getReactionSnomed().asSoyMap();
        }
        return mapped;
    };

    /**
     *  HELPER METHODS
     */
    _class.prototype.isActive = function() {
        return this.getStatus() === 'Active';
    };
    _class.prototype.setAsInactive= function() {
        this.setStatus('Inactive');
    };
    _class.prototype.setAsActive = function() {
        this.setStatus('Active');
    };
    _class.prototype.getAllergyName = function() {
        var allergy = this.getAllergy();
        return allergy.getName();
    };
    _class.prototype.getReactionSnomedDescription = function() {
        var reactionSnomed = this.getReactionSnomed();
        if (!reactionSnomed) return;
        return reactionSnomed.getDescription();
    }
    _class.prototype.getAllergy = function() {
        return el8.data.allergies.getById(this.getAllergyId());
    };
    _class.prototype.getReactionSnomed = function() {
        if (!this.getReactionSnomedId()) return;
        return el8.data.snomedCodes.getById(this.getReactionSnomedId());
    }
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.ptAllergies.summary(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.asMap = function() {
        return this.parent.asMap.call(this, true);
    };

    /**
     * Entity Set
     */
    var that = new el8.ptdata.model.PatientItemSet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('ptAllergies'); },
        saveFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Patient allergy being saved...');
            var saved = false;
            $.el8_ajax({
                url: el8.service.urls.get('ptAllergies', [item]),
                type: 'POST',
                async: false,
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    saved = true;
                    el8.ptdata.ptAllergies.setDocumented(data.is_documented);
                    if (window.el8React && el8React.legacyToReduxSynchronizer) {
                      el8React.legacyToReduxSynchronizer.setAllergiesDocumentedForPatient(
                        data.item.patient_id,
                        data.is_documented
                      );
                    }
                    if (item.getId()) {
                        el8.ptdata.ptAllergies.updateItemId(item, data.item.id);
                    }
                    item.populate(data.item);
                    if (successCallbackFn) { successCallbackFn(item); }
                    el8.appservice.notifier.notify('Patient allergy saved.');
                }
            });
            // Can only do this because async = false;
            return saved ? item : null;
        },
        deleteFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Patient allergy being deleted...');
            $.el8_ajax({
                url: el8.service.urls.get('ptAllergies', [item]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Patient allergy deleted.');
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
        }
    });

    // Set of methods to handle "NKDA" vs. unspecified

    that.saveAsDocumented = function() {
        $.el8_ajax({
            url: el8.service.urls.get('patientAllergyDocumentation'),
            type: 'POST',
            success: function(data) {
                that.setDocumented(true);
                if (window.el8React && el8React.legacyToReduxSynchronizer) {
                  el8React.legacyToReduxSynchronizer.setAllergiesDocumentedForPatient(
                    el8Globals.PATIENT_ID,
                    true
                  );
                }
                that.trigger(EVENTS.UPDATED);
            }
        });
    };
    that.deleteAsDocumented = function() {
        $.el8_ajax({
            url: el8.service.urls.get('patientAllergyDocumentation'),
            type: 'DELETE',
            success: function(data) {
                that.setDocumented(false);
                if (window.el8React && el8React.legacyToReduxSynchronizer) {
                  el8React.legacyToReduxSynchronizer.setAllergiesDocumentedForPatient(
                    el8Globals.PATIENT_ID,
                    false
                  );
                }
                that.trigger(EVENTS.UPDATED);
            }
        });
    };
    that.isDocumentedAsNone = function() {
        return !that.all().length && that.isDocumented();
    };
    that.isNotDocumented = function() {
        return !that.all().length && !that.isDocumented();
    };
    that.hasUserCreatedAllergies = function() {
        var allergies = that.all();
        return allergies.some(function(allergy) {
          return allergy.getAllergy().isUserCreated();
        });
    };

    // Additional helpful methods on el8_EntitySet
    that.getAllActive = function() {
        return that.all().filter(function(a) {
            return a.isActive();
        });
    };
    that.getAllInactive = function() {
        return that.all().filter(function(a) {
            return !a.isActive();
        });
    };
    that.getSummary = function() {
        return el8.template.ptdata.ptAllergies.patientSummary({
            actives: that.getAllActive().map(el8.model.toSoyMapFn),
            isDocumentedAsNone: that.isDocumentedAsNone()
        }).el8_unescape();
    };
    that.getDocumentedAsNoneSummary = function() {
        return that.isDocumentedAsNone() ?
            el8.template.ptdata.ptAllergies.documentedAsNoneSummary().el8_unescape() : '';
    };

    return that;
})();
